var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 3.375L5.00488 11.2185L8.35963 40.3009L26.9998 50.625L45.6399 40.3009L48.9946 11.2185L26.9998 3.375Z",
    fill: "#B42F53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3.375V8.61975V8.59612V32.5282V50.625L45.6401 40.3009L48.9949 11.2185L27 3.375Z",
    fill: "#912F48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9997 8.5957L13.25 39.4263H18.3766L21.1407 32.5278H32.8115L35.5756 39.4263H40.7023L26.9997 8.5957ZM31.016 28.2753H22.9835L26.9997 18.6127L31.016 28.2753Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.18de594a770e8914e933bb5763640949.svg";
export { ForwardRef as ReactComponent };